class ExportCsvModel {
    public FromDate: string;
    public ToDate: string;
    public VisitFromDate: string;
    public VisitToDate: string;
    public SiteIds: string;
    public ProviderIds: string;
    public BilledByIds: string;
    public PaymentMethod: string;
    public IsFromSales: string;
    public IsFromTransactions: string;
    public SearchText: string;
    public IsClosed: string;
    public IsOpen: string;
    public IsValid: string;
    public IsInvalid: string;
    public PaymentFromDate: string;
    public PaymentToDate: string;
}

export { ExportCsvModel };
